/**
 * Canonical poll schema constants shared by JSON upload and MCP tools.
 */

export const SCHEMA_VERSION = "1.0";

export const POLL_KIND = Object.freeze({
  SESSION: "SESSION",
  BASIC: "BASIC",
});

export const POLL_KINDS = Object.freeze(Object.values(POLL_KIND));

export const VOTE_TYPE = Object.freeze({
  MULTIPLE_CHOICE: "MULTIPLE_CHOICE",
  RANKED_CHOICE: "RANKED_CHOICE",
});

export const VOTE_TYPES = Object.freeze(Object.values(VOTE_TYPE));

export const VOTE_VISIBILITY = Object.freeze({
  FULL: "full_visibility",
  HIDDEN_WHILE_VOTING: "hidden_while_voting",
  HIDDEN_UNTIL_ALL_VOTED: "hidden_until_all_voted",
  HIDDEN_UNTIL_FINALIZED: "hidden_until_finalized",
  HIDDEN: "hidden",
});

export const VOTE_VISIBILITY_VALUES = Object.freeze(Object.values(VOTE_VISIBILITY));

export const VOTE_ANONYMIZATION = Object.freeze({
  NONE: "none",
  CREATOR_EXCLUDED: "creator_excluded",
  ALL_PARTICIPANTS: "all_participants",
});

export const VOTE_ANONYMIZATION_VALUES = Object.freeze(Object.values(VOTE_ANONYMIZATION));

/** Import modes for the upload dialog. */
export const IMPORT_MODE = Object.freeze({
  BASIC: "basic",
  SESSION: "session",
  ADDON: "addon",
});

/** Validation modes control which semantic rules are enforced. */
export const VALIDATION_MODE = Object.freeze({
  /** UI prefill: relaxed temporal checks (slots can be in past). */
  PREFILL: "prefill",
  /** MCP direct create: strict temporal checks. */
  CREATE: "create",
});

export const ERROR_CODES = Object.freeze({
  // Structural
  INVALID_JSON: "INVALID_JSON",
  SCHEMA_VALIDATION_ERROR: "SCHEMA_VALIDATION_ERROR",

  // Semantic
  SLOT_END_BEFORE_START: "SLOT_END_BEFORE_START",
  SLOT_IN_PAST: "SLOT_IN_PAST",
  NO_SLOTS: "NO_SLOTS",
  DUPLICATE_SLOT: "DUPLICATE_SLOT",
  TOO_FEW_OPTIONS: "TOO_FEW_OPTIONS",
  INVALID_MAX_SELECTIONS: "INVALID_MAX_SELECTIONS",
  MISSING_GROUP_ID: "MISSING_GROUP_ID",
  DEADLINE_IN_PAST: "DEADLINE_IN_PAST",
  INVALID_INVITEE_FORMAT: "INVALID_INVITEE_FORMAT",

  // Auto-corrected (warnings, not errors)
  AUTO_CORRECTED: "AUTO_CORRECTED",
});
